import React, {useEffect, useRef, useState} from 'react'
import useDebounceState from '../../hooks/useDebounceState';
import request from '../../api';
import {animated} from "react-spring";
import Loader from "../Loader";

const SearchInn = ({
  companies = [],
  setModalView,
  setSelectedCompany,
  setSelectedInn,
  selectedCopmany,
  searchTerm,
  setSearchTerm,
  searchResults,
  setSearchResults
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);

  const searchCompanies = (text) => {
    if (text && text.length >= 3) {
      setIsLoading(true);
      request("panpartner:company.ajax", "findCompany", {name: text})
        .then(data => {
          if (Array.isArray(data)) {
            setSearchResults(data);
          } else if (data && Array.isArray(data.companies)) {
            setSearchResults(data.companies);
          } else if (data && typeof data === 'object') {
            const results = Object.keys(data).map(key => {
              return typeof data[key] === 'object' ? data[key] : { id: key, name: data[key] };
            });
            setSearchResults(results);
          } else {
            setSearchResults([]);
          }
          setIsLoading(false);
        })
        .catch(error => {
          console.error("Error searching companies:", error);
          setSearchResults([]);
          setIsLoading(false);
        });
    } else {
      if (text === '') {
        setSearchResults([]);
      }
    }
  };

  const [debouncedSearchTerm, handleSearchTermChange] = useDebounceState({
    fn: (event) => searchCompanies(event.target.value),
    setState: (prev, event) => event.target.value,
    defaultState: '',
    delay: 300
  });

  const filteredData = searchResults.length > 0 ? searchResults : (searchTerm.length >= 3 ? [] : companies);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => setIsOpen(!isOpen);
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    handleSearchTermChange(event);
  };
  const handleSelect = (item) => {
    setSelectedItem(item);
    setIsOpen(false);
    setModalView('second')
  };

  return (
    <div className={'search-inn'}>

      <div className={'search-inn__select'} onClick={handleToggle}>
        <input
          type="text"
          value={selectedCopmany}
          readOnly
          placeholder="Поиск по названию или ИНН"
          className={'search-inn__input'}
        />
        <span className={'search-inn__arrow'}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.94501 11.25L12 14.2504L15.055 11.25" stroke="#777A89" stroke-linecap="round"/></svg></span>
      </div>
      {isOpen && (
        <div className={'search-inn__dropdown'} ref={dropdownRef}>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Введите название или ИНН"
              className={'search-inn__search-input'}
            />
            {isLoading && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                paddingRight: 10
              }}>
                <animated.div>
                  <Loader  loaderColor={'#8f95ac'}/>
                </animated.div>
              </div>
            )}
          </div>
          <div className={'search-inn__scrollable'}>
            {filteredData.map((item, index) => (
              <div
                key={index}
                className={'search-inn__item'}
                onClick={() => {
                  handleSelect(item)
                  setSelectedCompany(item.name)
                  setSelectedInn(item.id)
                }}>
                <span>{item.name}</span>
                <span className={'search-inn__inn'}>ИНН {item.id}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchInn;
